import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Link } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  description: {
    paddingTop: '2vh',
    fontSize: '16px',
    color: '#4e4e4e',
    textAlign: 'center',
    marginRight: '7vw',
    marginLeft: '7vw'
  },
  title: {
    fontWeight: 700,
    textAlign: 'center',
    fontSize: 32,
    marginTop: '8vh',
    lineHeight: 'normal'
  },
  repository: {
    textAlign: 'center',
    fontSize: 20,
    marginTop: '8vh',
    color: '#b15858'
  },
  url: {
    textAlign: 'center',
    fontSize: 20,
    marginTop: '1vh'
  }
}));

const Header = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        container
        justify="center"
        style={{ marginTop: '-1%' }}
      >
        <Grid item>
          <Typography className={classes.title}>Checkers in Haskell</Typography>
          <Typography className={classes.description} >Version of the game Checkers completely made in Haskell. The game deals with basic moves, invalid moves and if one of the players won. The game explores Haskell concepts such as List comprehension, Pattern matching and Guards.</Typography>
          <Typography className={classes.repository}>Repository</Typography>
          <Typography className={classes.url}>
            <Link
              component="a"
              href="https://github.com/davibaltar/haskell-checkers"
              target="_blank"
            >
              https://github.com/davibaltar/haskell-checkers
              </Link>
          </Typography>
        </Grid>
      </Grid>
      <hr style={{ borderColor: '#E8E8E8', borderTop: 'none', borderLeft: 'none', borderRight: 'none', paddingTop: '3vh' }} />
    </div>
  );
};


export default Header;